import React, { memo } from 'react'
import { Stack } from '@mui/material'

import Text from './Text'
import FaIcon from '../faIcon/FaIcon'

const HeaderWithIcon = ({ label, icon }) => {
  return (
    <Stack direction='row' spacing={0.8} alignItems='center'>
      <Text
        label={label}
        variant='h4'
        fontWeight={700}
        sx={{ fontSize: '1.25rem' }}
      />
      <FaIcon icon={icon} />
    </Stack>
  )
}

export default memo(HeaderWithIcon)
